// FLAG:useDocuAi — debug tracer for the bidirectional upload→AI-badge flow
// (browser ⇄ omxweb worker ⇄ DMS). See docs/bidirectional-comm-hardening-plan.md.
//
// No-op unless localStorage.bidiDebug === '1', so it can be flipped live in the browser console
// on ANY stage (dev cluster included) without a rebuild:  localStorage.bidiDebug = '1'
// Call sites all live inside useDocuAi-gated code, so this only ever traces DocuAI tenants.
//
// Every line carries the correlation key so one document can be grepped across all hops:
//   [BIDI] <stage> file=<id> minio=<id> ver=<id> jti=<id> :: <detail>
/* eslint-disable no-console */

export const bidiEnabled = (): boolean => {
  try {
    return typeof window !== 'undefined' && window.localStorage?.getItem('bidiDebug') === '1'
  } catch {
    return false
  }
}

type Ctx = Record<string, unknown>

export const bidiLog = (stage: string, ctx: Ctx = {}, detail = ''): void => {
  if (!bidiEnabled()) return
  const tags = Object.entries(ctx)
    .filter(([, v]) => v != null && v !== '')
    .map(([k, v]) => `${k}=${String(v)}`)
    .join(' ')
  // eslint-disable-next-line no-console
  console.log(`[BIDI] ${stage}${tags ? ` ${tags}` : ''}${detail ? ` :: ${detail}` : ''}`)
}
